import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import * as staticContent from "@/data/content";

const ContentContext = createContext({ content: null, loaded: false, refresh: () => {} });

export function ContentProvider({ children }) {
    const [content, setContent] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const load = useCallback(async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/content`);
            setContent(data);
        } catch (e) {
            // static fallback keeps the site alive if the API is unreachable
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return <ContentContext.Provider value={{ content, loaded, refresh: load }}>{children}</ContentContext.Provider>;
}

export function useSiteContent() {
    const { content, loaded } = useContext(ContentContext);
    const c = { ...staticContent, ...(content || {}) };
    c.CONTENT_LOADED = loaded;
    c.featuredProject = { ...staticContent.featuredProject, ...((content && content.featuredProject) || {}) };
    if (c.contact) {
        c.CONTACT_EMAIL = c.contact.email;
        c.LOCATION = c.contact.location;
        c.SOCIALS = { facebook: c.contact.facebook };
        c.VENMO = c.contact.venmo || "";
        c.DEPOSIT_LINK = c.contact.depositLink || "";
        c.BALANCE_LINK = c.contact.balanceLink || "";
    }
    return c;
}

export function useContentAdmin() {
    return useContext(ContentContext);
}
